<template>
  <!-- 个人中心-个人信息 -->
  <div class="main-contain">
    <div class="contain">
      <div class="theme">个人信息</div>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form ref="ruleForm" class="form-box" :model="ruleForm" :rules="formRules" label-position="right"
            label-width="100px">
            <el-form-item label="用户名">
              <div v-if="isShow" class="form-show">{{ ruleForm.name }}</div>
              <el-input v-else class="input_full" v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <div v-if="isShow" class="form-show">{{ ruleForm.mobile }}</div>
              <el-input v-else class="input_full" v-model="ruleForm.mobile" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="性别">
              <div v-if="isShow" class="form-show">{{ ruleForm.gender | genderFilter }}</div>
              <el-select v-else class="input_full" v-model="ruleForm.gender" placeholder="请选择">
                <el-option v-for="item in genderList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="isShow">
              <el-button type="primary" round @click="updateUserInfo">更新信息</el-button>
            </el-form-item>
            <el-form-item v-if="!isShow">
              <el-button type="primary" round @click="handleSubmit('ruleForm')">提交</el-button>
              <el-button round @click="handleReset('ruleForm')">取消</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <div class="user-avatar">
            <div v-loading="loading" element-loading-text="图片上传中..."
              element-loading-background="rgba(255, 255, 255, 0.4)" class="user-avatar--load">
              <el-avatar class="avatar" :src="ruleForm.avatar" :size="100" @error="errorHandler">
                <img :src="ruleForm.avatar" />
              </el-avatar>
            </div>
            <uploadAvatar :module="'user,avatar'" :cloudType="'user/avatar'" @setUrl="getUrl"
              @updateStatus="getStatus" />
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs"
import { getIdentifierToken, setWebAvaterToken, setWebNameToken } from "@/utils/auth"
import uploadAvatar from "@/components/uploadAvatar"
import { getuserinfo, edituserinfo } from "@/api/user"

const genderMap = {
  0: "未知",
  1: "男",
  2: "女"
}
export default {
  name: "Personal",
  components: {
    uploadAvatar,
  },
  data() {
    return {
      identifier: 1,
      ruleForm: {
        name: "",
        mobile: "",
        gender: "",
        avatar: "",
      },
      formRules: {
        // name: [
        //   { required: true, message: '请输入用户姓名', trigger: ['blur', 'change'] }
        // ],
      },
      loading: false,
      genderList: [
        { id: 0, name: "未知" },
        { id: 1, name: "男" },
        { id: 2, name: "女" }
      ],
      collegeList: [],
      schoolList: [],
      schoolParames: {
        keyword: "",
        per_page: 10,
        page: 1,
      },
      schoolMoreItems: true, // 是否还有更多选项
      educationList: [],
      isShow: true, // 是否展示
      getImgStatus: false,
    }
  },
  filters: {
    dataformat(value) {
      if (!value) return ""
      return dayjs.unix(value).format("YYYY-MM-DD HH:mm:ss")
    },
    genderFilter(val) {
      return genderMap[val]
    },
  },
  watch: {
    getImgStatus: {
      handler(newV) {
        this.loading = newV
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.identifier = Number(getIdentifierToken()) || 1
    this.getInfo() // 获取用户信息
  },
  methods: {
    // 获取详情
    getInfo(params) {
      getuserinfo(params).then((res) => {
        if (res.code === 0) {
          this.ruleForm = {
            name: res.data.name,
            mobile: res.data.mobile,
            gender: res.data.gender,
            avatar: res.data.avatar,
          }
        }
      }).catch(() => { })
    },
    errorHandler() {
      return "https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png"
    },
    // 获取上传头像
    getUrl(data) {
      const url = JSON.parse(data)
      if (url.length > 0) {
        this.ruleForm.avatar = url[0].url
      }
      const params = {
        avatar: this.ruleForm.avatar,
        name: this.ruleForm.name
      }
      this.edituserinfo(params)
    },

    // 更新个人信息
    updateUserInfo() {
      this.isShow = false
    },
    // 更改个人信息
    edituserinfo(params) {
      edituserinfo(params).then((res) => {
        if (res.code === 0 && res.data) {
          this.$store.commit("SET_Useravater", res.data.avatar)
          this.$store.commit("SET_Username", res.data.name)
          setWebAvaterToken(res.data.avatar)
          setWebNameToken(res.data.name)
          this.$message({
            message: "个人信息更新成功!",
            type: "success",
          })
        }
        this.getInfo()
      }).catch(() => { })
    },
    // 提交数据
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.mobile = ""
          const params = Object.assign({}, this.ruleForm)
          this.edituserinfo(params)
          this.isShow = true
        } else {
          return false
        }
      })
    },
    // 取消提交
    handleReset(formName) {
      this.$refs[formName].resetFields()
      this.isShow = true
    },
    getStatus(data) {
      this.getImgStatus = data
    }
  },
};
</script>
<style lang="scss" scoped>
.main-contain {
  padding: 10px;

  .contain {
    height: 100%;
    background: #ffffff;
    box-sizing: border-box;
    padding: 20px 20px;

    .theme {
      color: #000000;
      font-size: 16px;
      font-weight: bold;
      text-indent: 100px;
      line-height: 30px;
      margin-bottom: 20px;
    }

    .form-box {
      ::v-deep .el-form-item__content {
        line-height: normal;
        display: flex;
      }

      .input_full {
        width: 100%;
      }

      .form-show {
        display: inline-block;
        color: #666;
        font-size: 14px;
        font-weight: 400;
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding: 0 10px;
        background: #f9f9f9;
        border-radius: 5px;
        border: 1px solid #f2f4f8;
        box-sizing: border-box;
      }
    }

    .user-avatar {
      width: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;

      .user-avatar--load {
        width: 100px;
        height: 100px;
        margin-bottom: 20px;
      }

      .avatar {
        margin-bottom: 20px;
        background: #f9f9f9;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .left,
    .right {
      border: 1px solid #000;
    }
  }
}

.btn-primary {
  color: #fff;
  background-color: #005cbb;
  border-color: #005cbb;
}

.btn-primary.is-plain {
  color: #005cbb;
  background: #fff;
  border-color: #005cbb;
}

// .main-contain {
//   padding: 10px;
//   .update-btn {
//     padding: 0px 20px 20px;
//   }
//   .contain {
//     height: 100%;
//     background: #ffffff;
//     padding: 15px 20px 20px;

//     .left {
//       height: 100%;

//       // padding: 20px;
//       .text1 {
//         font-size: 20px;
//         font-weight: 500;
//         color: #222222;
//       }

//       .outsite_con {
//         margin-top: 20px;

//         .input_full {
//           width: 340px;
//         }

//         .email_text {
//           font-size: 14px;
//           font-weight: 500;
//           padding: 0px 12px;
//           color: #005cbb;
//           cursor: pointer;
//         }
//       }

//       .text2 {
//         margin-top: 10px;
//         font-size: 15px;
//         font-weight: 500;
//         color: #666666;
//       }

//       // .bt {
//       //   margin-top: 40px;
//       //   width: 88px;
//       //   height: 42px;
//       //   line-height: 42px;
//       //   text-align: center;
//       //   background: #3d84ff;
//       //   border-radius: 5px;;
//       //   color: #ffffff;
//       //   user-select: none;
//       //   cursor: pointer;
//       // }
//     }

//     .right {
//       height: 100%;
//       display: flex;
//       justify-content: flex-end;
//       align-items: center;

//       .contain {
//         margin-right: 100px;
//         margin-top: 40px;

//         .tiptext {
//           text-align: center;
//           font-size: 16px;
//           color: #555555;
//         }
//       }
//     }
//   }
// }

@media screen and (max-width: 640px) {
  .main-contain {
    padding: 5px;

    .contain {
      padding: 15px 10px;

      .theme {
        text-indent: 0;
        font-size: 16px;
      }

      ::v-deep .el-row {
        display: flex;
        flex-direction: column;

        .el-col {
          width: 100%;
          max-width: 100%;
          flex: 0 0 100%;
        }

        .el-col:last-child {
          order: -1;
        }
      }

      .form-box {
        ::v-deep .el-form-item__label {
          width: 70px !important;
        }

        ::v-deep .el-form-item__content {
          margin-left: 70px !important;
        }
      }

      .user-avatar {
        margin-top: 0;
        margin-bottom: 20px;
      }
    }
  }
}

@media screen and (min-width: 640px) and (max-width: 1200px) {
  .main-contain {
    .contain {
      ::v-deep .el-row {
        .el-col {
          width: 50%;
          max-width: 50%;
          flex: 0 0 50%;
        }
      }
    }
  }
}
</style>